var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('c3-chart',{ref:"chart",attrs:{"height":_vm.height,"data":_vm.chartData,"config":_vm.chartConfig,"type":"area"}}):_c('v-skeleton-loader',{attrs:{"type":"image","height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }